"use client";

import React from "react";
import { ArrowRight, Activity } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PerformanceAssessmentPromo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15,
    once: true
  });
  return <section id="performanceassessmentpromo" data-nav="light" ref={ref} className="bg-background text-foreground py-16 md:py-20 border-t border-border/60 isolate">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div style={{
        opacity: isVisible ? 1 : 0
      }} className={`relative overflow-hidden rounded-2xl bg-card border border-border/80 p-8 sm:p-10 md:p-12 shadow-sm transition-all duration-700 ease-out transform ${isVisible ? "translate-y-0" : "translate-y-4"}`}>
          {/* Subtle decorative background accent */}
          <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-primary/5 blur-2xl pointer-events-none -z-10" aria-hidden="true" />

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2.5 text-primary mb-3.5">
                <span className="p-1.5 rounded-md bg-primary/10">
                  <Activity className="size-4 text-primary" aria-hidden="true" />
                </span>
                <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                  PhysAnalytica Comprehensive Services
                </span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground font-default">
                Looking for a more complete performance assessment?
              </h2>
              <p className="mt-3 text-base text-muted-foreground leading-relaxed">
                PhysAnalytica can combine metabolic testing with specialist biomechanics and movement assessment where appropriate. Contact us to discuss your goals.
              </p>
            </div>

            <div className="shrink-0 flex items-center">
              <Button asChild size="lg" className="w-full sm:w-auto shadow-sm">
                <Link to="#">
                  Discuss a Performance Assessment
                  <ArrowRight className="size-4 ml-1.5" aria-hidden="true" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}